import React from "react";

const UserAvatar = ({ username, image_url, email }) => {
  return (
    <div className="d-flex flex-row justify-content-start align-items-center gap-2">
      {image_url !== null ? (
        <img
          alt="user"
          src={image_url}
          loading="lazy"
          width={48}
          height={48}
          className="rounded-circle object-fit-cover"
        />
      ) : (
        ""
      )}
      <div className="d-flex flex-column align-items-start">
        <div className="lc-2"> {`${username} `} </div>
        {email ? (
          <div className="lc-1  text-sm-start gray-text text-wrap-custom">
            {`${email} `}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default UserAvatar;
